export default __webpack_public_path__ + "static/media/product-collect-blood.f06eddb5.svg";